/**
 * Converts TextRestrictions into a regex pattern string that matches the allowed characters.
 * This matches the exact patterns from the origin system:
 * - number: "0-9"
 * - upper: "A-Z&'"
 * - lower: "a-z"
 * - titlecase: "a-zA-Z"
 * - uppercase: "A-Z& "
 * - lowercase: "a-z "
 * - titlecase: "a-zA-Z "
 * - symbols: "A-Z0-9\\s./&'"
 * - symbolsTitlecase: "a-zA-Z0-9\\s./&'"
 * - any: "A-Za-z0-9&"
 * - allChars: "A-Za-z0-9\\s!@#$%^&*()_+\\-=\\[\\]{};'\"\\\\|,.<>?\\/~`"
 *
 * @param restrictions - The text restrictions to convert
 * @returns A regex pattern string matching the original system
 */
export const getRegexFromRestrictions = (restrictions) => {
  // Match the exact patterns based on the combination of restrictions
  if (
    restrictions.allowNumbers &&
    !restrictions.allowLetters &&
    !restrictions.allowSpaces &&
    !restrictions.allowSymbols
  ) {
    return '0-9'; // number
  }

  if (
    restrictions.allowLetters &&
    restrictions.allowSymbols &&
    !restrictions.allowSpaces &&
    !restrictions.allowNumbers
  ) {
    if (restrictions.allowedTextCase === 'UPPER') {
      return "A-Z&'"; // upper
    }
  }

  if (
    restrictions.allowLetters &&
    !restrictions.allowSymbols &&
    !restrictions.allowSpaces &&
    !restrictions.allowNumbers
  ) {
    if (restrictions.allowedTextCase === 'LOWER') {
      return 'a-z'; // lower
    }
    if (restrictions.allowedTextCase === 'SENTENCE') {
      return 'a-zA-Z'; // titlecase
    }
  }

  if (restrictions.allowLetters && restrictions.allowSpaces) {
    if (!restrictions.allowNumbers) {
      if (restrictions.allowedTextCase === 'UPPER' && restrictions.allowSymbols) {
        return 'A-Z& '; // uppercase
      }
      if (restrictions.allowedTextCase === 'LOWER' && !restrictions.allowSymbols) {
        return 'a-z '; // lowercase
      }
      if (restrictions.allowedTextCase === 'SENTENCE' && !restrictions.allowSymbols) {
        return 'a-zA-Z '; // titlecase
      }
    }
  }

  if (
    restrictions.allowLetters &&
    restrictions.allowNumbers &&
    restrictions.allowSpaces &&
    !restrictions.allowSymbols
  ) {
    if (restrictions.allowedTextCase === 'MIXED') {
      return 'a-zA-Z0-9 '; // letters, numbers, and spaces only
    }
  }

  if (restrictions.allowLetters && restrictions.allowNumbers && restrictions.allowSpaces && restrictions.allowSymbols) {
    if (restrictions.allowedTextCase === 'UPPER') {
      return "A-Z0-9\\s./&'"; // symbols
    }
    if (restrictions.allowedTextCase === 'SENTENCE') {
      return "a-zA-Z0-9\\s./&'"; // symbolsTitlecase
    }
    if (restrictions.allowedTextCase === 'MIXED') {
      return 'A-Za-z0-9\\s!@#$%^&*()_+\\-=\\[\\]{};\'\"\\\\|,.<>?\\/~`'; // allChars
    }
  }

  if (
    restrictions.allowLetters &&
    restrictions.allowNumbers &&
    restrictions.allowSymbols &&
    !restrictions.allowSpaces
  ) {
    if (restrictions.allowedTextCase === 'MIXED') {
      return 'A-Za-z0-9&'; // any
    }
  }

  // Default fallback - though this should never happen if TextRestrictions are properly set
  return 'A-Za-z';
};
